// Module
var code = "<inquiry\n  variant-id=\"vm.variant.id\"\n  article-node-group=\"vm.nodeGroup\"\n  initial-branch-id=\"vm.initialBranchId\"\n  initial-supplier-id=\"vm.initialSupplierId\"\n  initial-lifecycle=\"vm.initialLifecycle\"\n></inquiry>\n";
// Exports
module.exports = code;